<div
  #alertErrorRef
  [ngClass]="
    'idp-form-alert idp-form-alert__justify-content-' + contentAlignment
  "
  (keydown)="focusOutAction($event)"
  [tabindex]="tabIndex"
  (keydown.escape)="onClosePopup()"
>
  @if (message) {
    <p>
      <i
        [ngClass]="successIcon ? 'idp-icon-success' : 'idp-icon-alert'"
        aria-hidden="true"
      ></i>
      <span [innerHTML]="message"></span>
      @if (showCloseButton) {
        <span>
          <button
            tabindex="1"
            aria-label="Close"
            type="button"
            class="idp-info-tooltip__wrapper--close"
            (click)="onClosePopup()"
            (keydown.enter)="onClosePopup()"
          >
            <i class="idp-close-icon"></i>
          </button>
        </span>
      }
    </p>
  }
  @if (alertMessages && alertMessages.length > 0) {
    <section class="idp-form-alert__messages">
      @for (alertMessage of alertMessages; track alertMessage) {
        <div class="idp-form-alert__messages--group">
          <p>
            <i
              [ngClass]="successIcon ? 'idp-icon-success' : 'idp-icon-alert'"
              aria-hidden="true"
            ></i>
            <span [innerHTML]="alertMessage"></span>
          </p>
        </div>
      }
    </section>
  }
</div>
